import { render, staticRenderFns } from "./resourceUploadRule.vue?vue&type=template&id=365f56dd&scoped=true&"
import script from "./resourceUploadRule.vue?vue&type=script&lang=ts&"
export * from "./resourceUploadRule.vue?vue&type=script&lang=ts&"
import style0 from "./resourceUploadRule.vue?vue&type=style&index=0&id=365f56dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f56dd",
  null
  
)

export default component.exports